import { useMemo } from 'react';
import { ListWithLoadingStateLayout } from './ListWithLoadingStateLayout';

export function useListWithLoadingStateLayout<T>({
  loadingState,
  loadingSkeletonRowsCount,
  sectionDividerHeight = 5,
  headingHeight = 34, // default css height
}: {
  loadingState?: 'loading' | 'loadingMore';
  loadingSkeletonRowsCount: number;
  sectionDividerHeight?: number;
  headingHeight?: number;
}) {
  const layout = useMemo(
    () =>
      new ListWithLoadingStateLayout<T>({
        /**
         * The estimated height is an average between the min and max height
         * of list items built with our own exports. Which is the only way
         * to render InteractiveList items.
         */
        estimatedRowHeight: 60,
        loadingState,
        sectionDividerHeight,
        headingHeight,
        loadingRowsCount: loadingSkeletonRowsCount,
      }),
    [
      loadingState,
      loadingSkeletonRowsCount,
      sectionDividerHeight,
      headingHeight,
    ]
  );

  return layout;
}
